export const config = {
	serviceManagementBackendUrl: 'https://localhost:44377/',
	identityServerUrl: 'http://localhost:57065/',
	tinyMceApiKey: '2lik903ruo71pr3kx4x6py3377emf8y6hssqdzk0rrk5sija'
}
export default config
